import "./rma-report-button.scss";
import { observer } from "mobx-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { IReportFiltersType, REPORT_TYPES } from "../../../../../services/api/report-service";
import ReportStore from "../../../../../stores/report-store";
import IconDownload from "../../../../../components/icons/icon-download/icon-download";
import RoundLoader from "../../../../../components/loaders/round-loader/round-loader";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import RmaReportExpandedBox from "./rma-report-expanded-box";
import IconDropDownSmallArrow from "../../../../../components/icons/icon-drop-down-small-arrow/icon-drop-down-small-arrow";
import IconDropDownUpSmallArrow from "../../../../../components/icons/icon-drop-down-up-small-arrow/icon-drop-down-up-small-arrow";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";

interface IReportProps {
    getReportFilters?: () => IReportFiltersType;
}

const RmaReportButton: React.FC<IReportProps> = observer(({ getReportFilters }) => {
    const store = useMemo<ReportStore>(() => new ReportStore(REPORT_TYPES.RETURNS, getReportFilters), [getReportFilters]);

    const [isExpanded, setIsExpanded] = useState(false);
    const generatedDate = store.lastGenerated ? new Date(store.lastGenerated.updated_at) : undefined;

    useEffect(() => {
        store.load();
    }, [store]);
    const refrerence = useRef<HTMLSpanElement>(null);

    const isLoading = store.isGenerating || store.isLoading;

    const onClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        rmsMixpanelStore.trackEvent('d&_report');
        if (!store.lastGenerated) {
            store.generateReport();
        } else {
            setIsExpanded(!isExpanded);
        }
    }

    const {getTranslation} = useDashboardTranslation();
    const scope = 'dashboard-returns-page';

    return (
        <div className="rma-report-container">
            <span className={`rma-report-button ${isLoading ? 'loading' : ''}`} ref={refrerence} onClick={onClick}>
                <span className={`rma-report-button-title`}>
                    {isLoading ? <RoundLoader /> : <IconDownload />}
                    <FontBody1 color={isLoading ? FONT_COLOR.NEUTRAL_WHITE : FONT_COLOR.ACCENT1}>{getTranslation('REPORT', scope)}</FontBody1>
                </span>
                {store.lastGenerated && (
                    <span className={`select-dropdown-indicator${isExpanded ? ' expanded' : ''}`}>
                        {isExpanded ? <IconDropDownUpSmallArrow color="var(--color-neutral-1-white)" /> : <IconDropDownSmallArrow />}
                    </span>)}
            </span>
            {(isExpanded && store.lastGenerated) && (
                <RmaReportExpandedBox
                    refElement={refrerence.current}
                    isGeneratingReport={store.isGenerating}
                    onClick={() => {
                        setIsExpanded(false);
                    }}
                    onGenerateNewClick={() => {
                        setIsExpanded(false);
                        store.generateReport();
                    }}
                    report={store.lastGenerated}
                    reportStore={store}
                />
            )}
        </div>
    );
});

export default RmaReportButton;
